<template>
  <b-card>
    <div class="d-flex flex-wrap w-100">
      <b-col md="12">
        <h4 class="mb-2 text-primary font-weight-bolder text-uppercase">
          Summary
        </h4>
      </b-col>
    </div>
    <div class="d-flex flex-wrap w-100">
      <b-col md="12">
        <h6 class="mb-1 text-secondary font-weight-bolder text-uppercase ts-title">
          Campaign Details
        </h6>
      </b-col>
    </div>
    <div class="d-flex flex-wrap w-100">
      <b-col md="4">
        <p class="text-header">
          Campaign ID</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ dataReview.campaign_id }}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Campaign Name</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ dataReview.campaign_name }}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Campaign Description</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ dataReview.description }}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Creator</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ dataReview.creator }}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Approver</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ dataReview.approval_by }}</p>
      </b-col>
      <!-- <b-col
        :class="(dataReview.channel_id === 3 && dataReview.method_id === 3) ? 'd-none' : 'd-block'"
        md="4"
      >
        <p class="text-header">
          Bid Price</p>
      </b-col>
      <b-col
        :class="(dataReview.channel_id === 3 && dataReview.method_id === 3) ? 'd-none' : 'd-block'"
        md="6"
      >
        <p class="text-child">
          {{ setInt(dataReview.bid_price) }} %</p>
      </b-col> -->
      <!-- <b-col
        md="4"
      >
        <p class="text-header">
          Ad Budget</p>
      </b-col>
      <b-col
        md="6"
      >
        <p class="text-child">
          IDR {{ formatPrice(dataReview.budget) }} </p>
      </b-col> -->
      <b-col md="4">
        <p class="text-header">
          Channel Name</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ dataReview.channel_name }}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Buying Method</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ dataReview.method_name }} </p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Channel Schedule</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ formatDateIdr(dataReview.start_date) }} - {{ formatDateIdr(dataReview.end_date) }}</p>
      </b-col>
      <b-col md="12" v-if="dataReview.scheduling">
        <p class="text-header">
          Channel Time</p>
      </b-col>
      <b-col md="12">
        <div
          v-for="(data, i) in dataScheduling"
          :key="i"
          class="d-flex"
        >
          <p class="text-child w-10 font-weight-bolder text-center">
            <span>{{ data[0].day }}</span><br>
            <span>{{ i }}</span>
          </p>
          <div class="d-flex flex-wrap justify-content-start w-90">
            <p
              v-for="(dt, k) in dataScheduling[i]"
              :key="k"
              class="text-child text-right pl-1 text-center"
            >
              <span>{{ dt.time }}</span><br>
              <span>{{ dt.price }}</span>
            </p>
          </div>
        </div>
      </b-col>
    </div>
    <div class="d-flex flex-wrap w-100">
      <b-col md="12">
        <h6 class="mb-1 mt-2 text-secondary font-weight-bolder text-uppercase ts-title">
          KPI
        </h6>
      </b-col>
    </div>
    <div class="d-flex flex-wrap w-100">
      <b-col md="4">
        <p class="text-header">
          Key Performance Indicator</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ cappingType }} </p>
      </b-col>
    </div>
    <div
      v-if="cappingType !== 'no capping'"
      class="d-flex flex-wrap w-100"
    >
      <b-col
        md="4"
      >
        <p class="text-header">
          Total Value</p>
      </b-col>
      <b-col
        md="6"
      >
        <p class="text-child">
          {{ formatPrice(cappingValue) }} </p>
      </b-col>
      <b-col
        md="4"
      >
        <p class="text-header">
          Limiter</p>
      </b-col>
      <b-col
        md="6"
      >
        <p class="text-child">
          {{ cappingLimit }} </p>
      </b-col>
    </div>
    <!-- <div
      v-if="(dataReview.channel_id === 2 ||
        dataReview.channel_id === 4 ||
        (dataReview.channel_id === 5 && dataReview.content.delivery_type === 2)) && isAdmin && dataReview.status === '2'"
      class="d-flex flex-wrap w-100"
    >
      <b-col
        md="4"
      >
        <p class="text-header">
          Set Default Campaign</p>
      </b-col>
      <b-col md="6">
        <label class="switchCreateCampaign">
          <input
            id="toggle_btnCreateCampaign"
            v-model="dataReview.default_campaign"
            type="checkbox"
            @change="setDefaultCampaign"
          >
          <span class="sliderCreateCampaign round" />
        </label>
      </b-col>
    </div> -->
    <!-- <b-col md="12"> -->

    <!-- TARGET AUDIENCE -->
    <div class="d-flex flex-wrap w-100 mt-2">
      <b-col md="12">
        <h6 class="mb-1 text-secondary font-weight-bolder text-uppercase ts-title">
          Target Audience <span v-if="targetingType === 'visualization'" class="text-dark" style="font-size: 10px;">(Data DSV)</span>
        </h6>
      </b-col>
    </div>
    <div
      v-if="dataReview.targeting !== null && targetingType === 'upload'"
      class="d-flex flex-wrap w-100"
    >
      <b-col md="12">
        <b-alert
          show
          variant="primary"
        >
          <div class="alert-body">
            <feather-icon
              class="mr-25"
              icon="UploadCloudIcon"
            />
            <span class="ml-25">Profile target data using file uploader.</span>
          </div>
        </b-alert>
      </b-col>
    </div>
    <!-- TARGET AUDIENCE MANUAL -->
    <div
      v-if="dataReview.targeting !== null && targetingType === 'setup'"
      class="d-flex flex-wrap w-100"
    >
      <b-col md="4">
        <p class="text-header">
          Age</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ dataReview.targeting.minAge && dataReview.targeting.maxAge ? dataReview.targeting.minAge + " - " + dataReview.targeting.maxAge + " y.o." : "-" }}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Gender</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ dataReview.targeting.gender.length !== 0 ? setString(dataReview.targeting.gender) : "-" }}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Province</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{dataReview.targeting.locationProvince}}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Kabupaten</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{dataReview.targeting.locationKabupaten}}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Kecamatan</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{dataReview.targeting.locationKecamatan}}</p>
      </b-col>
      <!-- <b-col md="4">
        <p class="text-header">
          ARPU</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          IDR {{ formatPrice(dataReview.targeting.min_arpu) }} - IDR {{ formatPrice(dataReview.targeting.max_arpu) }}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Location</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ viewText(getLocation, dataReview.targeting.location) }}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Interest</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ viewText(getInterest, dataReview.targeting.interest) }}</p>
      </b-col>
      <b-col md="4">
        <p class="text-header">
          Device</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{ setString(dataReview.targeting.device) }}</p>
      </b-col> -->
    </div>
    <!-- END TARGET AUDIENCE MANUAL -->
    <!-- TARGET AUDIENCE DSV -->
    <div
      v-if="dataReview.targeting !== null && targetingType === 'visualization'"
      class="d-flex flex-wrap w-100"
    >
      <div class="d-flex flex-wrap w-100" v-for="(item, i) in this.dataReview.targeting.dataDsv" :key="i">
          <b-col md="4">
            <p class="text-header">
              {{item.columnName}}</p>
          </b-col>
          <b-col md="6">
            <p class="text-child">
              {{setString(item.values)}}</p>
          </b-col>
      </div>
    </div>
    <!-- END TARGET AUDIENCE DSV -->
    <!-- END TARGET AUDIENCE -->

    <!-- SEGMENTS SELECTION TARGETING -->
    <div class="d-flex flex-wrap w-100" v-if="dataReview.targeting !== null && targetingType === 'setup'">
      <b-col md="12">
        <h6 class="mb-1 mt-2 text-secondary font-weight-bolder text-uppercase ts-title">
          Selection Segments Targeting
        </h6>
      </b-col>
    </div>
    <div
      v-if="dataReview.targeting !== null && targetingType === 'setup'"
      class="d-flex flex-wrap w-100"
    >
      <b-col md="6">
        <p class="text-header">
          Selection User Persona</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{
            dataReview.targeting.selectionSegmentsTargeting.selectionUserPersona.length !== 0 ? setString(dataReview.targeting.selectionSegmentsTargeting.selectionUserPersona) : "No Selection"
          }}
          </p>
      </b-col>
      <b-col md="6">
        <p class="text-header">
          Selection App</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{
            dataReview.targeting.selectionSegmentsTargeting.selectionApp.length !== 0 ? setString(dataReview.targeting.selectionSegmentsTargeting.selectionApp) : "No Selection"
          }}
          </p>
      </b-col>
      <b-col md="6">
        <p class="text-header">
          Selection Engagement by App</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{
            dataReview.targeting.selectionSegmentsTargeting.selectionEngagementbyApp.length !== 0 ? setString(dataReview.targeting.selectionSegmentsTargeting.selectionEngagementbyApp) : "No Selection"
          }}
          </p>
      </b-col>
      <b-col md="6">
        <p class="text-header">
          Selection Visitor</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{
            dataReview.targeting.selectionSegmentsTargeting.selectionVisitor.length !== 0 ? setString(dataReview.targeting.selectionSegmentsTargeting.selectionVisitor) : "No Selection"
          }}
          </p>
      </b-col>
      <b-col md="6">
        <p class="text-header">
          Selection Commuter</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{
            dataReview.targeting.selectionSegmentsTargeting.selectionCommuter.length !== 0 ? setString(dataReview.targeting.selectionSegmentsTargeting.selectionCommuter) : "No Selection"
          }}
          </p>
      </b-col>
      <b-col md="6">
        <p class="text-header">
          Selection Neigbourhood Tier</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{
            dataReview.targeting.selectionSegmentsTargeting.selectionNeigbourhoodTier.length !== 0 ? setString(dataReview.targeting.selectionSegmentsTargeting.selectionNeigbourhoodTier) : "No Selection"
          }}
          </p>
      </b-col>
      <b-col md="6">
        <p class="text-header">
          Selection POI Category</p>
      </b-col>
      <b-col md="6">
        <p class="text-child">
          {{
            dataReview.targeting.selectionSegmentsTargeting.selectionPOICategory.length !== 0 ? setString(dataReview.targeting.selectionSegmentsTargeting.selectionPOICategory) : "No Selection"
          }}
          </p>
      </b-col>
    </div>
    <!-- END SEGMENTS SELECTION TARGETING -->

    <!-- CONTENT DETAIL -->
    <!-- <div class="d-flex flex-wrap w-100">
      <b-col md="12">
        <h6 class="mb-1 mt-2 text-secondary font-weight-bolder text-uppercase ts-title">
          Content Details
        </h6>
      </b-col>
    </div>
    <review-sms
      v-if="dataReview.channel_id === 1"
      :data-review="dataReview"
    />
    <review-ussd
      v-if="dataReview.channel_id === 2"
      :data-review="dataReview"
    />
    <review-flash
      v-if="dataReview.channel_id === 3"
      :data-review="dataReview"
    />
    <review-banner
      v-if="dataReview.channel_id === 4"
      :data-review="dataReview"
    />
    <review-bima
      v-if="dataReview.channel_id === 5"
      :data-review="dataReview"
    />
    <review-ibn
      v-if="dataReview.channel_id === 6"
      :data-review="dataReview"
    /> -->
    <!-- END CONTENT DETAIL -->

    <div class="d-flex flex-wrap w-100 mt-2">
      <b-col md="8">
        <span
          class="target-audience-number-text font-medium-1 font-weight-bolder"
        >
          Forecasted Target Audience
        </span>
      </b-col>
      <b-col md="4">
        <span
          class="target-audience-number font-medium-3 font-weight-bolder text-primary"
        >
          {{ formatPrice(dataReview.audience) }}
        </span>
      </b-col>
    </div>
  </b-card>
</template>

<script>
import {
  BCol,
  BCard,
  BAlert,
} from 'bootstrap-vue'
import reviewSms from '@/views/page/campaign/reviewAndConfirm/sms.vue'
import reviewUssd from '@/views/page/campaign/reviewAndConfirm/ussd.vue'
import reviewFlash from '@/views/page/campaign/reviewAndConfirm/flashMessage.vue'
import reviewBanner from '@/views/page/campaign/reviewAndConfirm/digitalAdsBanner.vue'
import reviewBima from '@/views/page/campaign/reviewAndConfirm/Bima.vue'
import reviewIbn from '@/views/page/campaign/reviewAndConfirm/Ibn.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    // BRow,
    BAlert,
    BCol,
    BCard,
    reviewSms,
    reviewUssd,
    reviewFlash,
    reviewBanner,
    reviewBima,
    reviewIbn,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dataReview: Object,
  },
  data() {
    return {
      dataScheduling: [],
      internal: this.$store.state.auth.userData.data.company.internal_company === 0 || this.$store.state.auth.userData.data.Account.role_id === 2,
      startDate: '',
      endDate: '',
      targetingType: '',
      cappingType: '',
      cappingValue: '',
      cappingLimit: '',
      isAdmin: this.$store.state.auth.userData.data.Account.role_id === 2 && this.$store.state.auth.userData.data.departement.id === 1,
      // defaultCampaign: (this.$store.state.campaign.formCampaign.default_campaign === 1),
    }
  },
  computed: {
    ...mapGetters('datas', {
      getInterest: 'getInterest',
      getLocation: 'getLocation',
    }),
    ...mapGetters('campaign', {
      dataReviews: 'getCampaignDetail',
    }),
  },
  mounted() {
    // console.log(this.dataReview)
  },
  beforeUpdate() {
    // console.log(this.dataReview, 'data nih')
    if (this.dataReview.scheduling?.rate_card_id.length > 0) {
      this.sheduleFormat()
    }
    this.startDate = this.formatDateIdr(this.dataReview.start_date)
    this.endDate = this.formatDateIdr(this.dataReview.end_date)
  },
  updated() {
    this.targetingType = this.dataReview.targeting.type
    this.cappingType = this.dataReview.capping.type
    this.cappingValue = this.dataReview.capping.value
    this.cappingLimit = this.dataReview.capping.limit
  },
  methods: {
    ...mapActions('campaign', [
      'updateDefaultCampaign',
    ]),
    setDefaultCampaign() {
      let campaignId = this.dataReview.campaign_id
      if (this.dataReview.default_campaign) {
        this.$store.state.campaign.campaignDetail.default_campaign = 1
        this.updateDefaultCampaign({ campaign_id: campaignId, default_campaign: 1 }).then(res => {
          if (typeof (res.status) !== 'undefined' && !res.status) {
            this.failed(res.data)
          } else if (typeof (res.status) !== 'undefined' && res.status) {
            this.$store.state.campaign.campaignDetail.default_campaign = 1
          } else {
            this.$store.state.campaign.campaignDetail.default_campaign = 0
          }
        })
      } else {
        this.$store.state.campaign.campaignDetail.default_campaign = 0
        this.updateDefaultCampaign({ campaign_id: campaignId, default_campaign: 0 })
      }
    },
    failed(datas) {
      // console.log(type, 'types')
      let title = 'Failed'
      let text = datas.message
      this.$swal({
        title,
        text,
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then(result => {
        if (result.value) {
          this.$store.state.campaign.campaignDetail.default_campaign = 0
        }
      })
    },
    setString(data) {
      let str = (data) || []
      let textStr = str.join(', ')
      return textStr
    },
    formatDateIdr(date) {
      let dd = date?.replace(/-/g, '/')
      let d = new Date(dd)
      const dt = (`0${d.getDate()}`).slice(-2)
      const month = (`0${d.getMonth() + 1}`).slice(-2)
      const year = d.getFullYear()
      return `${dt}/${month}/${year}`
    },
    formatPrice(value) {
      if (value === null || typeof value === 'undefined') {
        return 0
      }
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    groupBy(objectArray, property) {
      return objectArray.reduce((acc, obj) => {
        const key = obj[property]
        if (!acc[key]) {
          acc[key] = []
        }
        // Add object to list for given key's value
        acc[key].push(obj)
        return acc
      }, {})
    },
    sheduleFormat() {
      const dta = this.dataReview.scheduling?.rate_card_id
      const group = this.groupBy(dta, 'date')
      this.dataScheduling = group
    },
    setInt(val) {
      // eslint-disable-next-line radix
      return parseInt(val)
    },
    viewText(data, arrList) {
      if (arrList.toString() === 'ALL') {
        return this.setString(arrList)
      }
      const inter = data.filter(item => arrList.find(val => val === item.value))
      const textInterest = inter.map(item => item.text)
      return this.setString(textInterest)
    },
  },
}
</script>

<style scoped>
.text-header {
  font-size: 14px;
  color: #5E5873;
  font-weight: bold;
}
.text-child {
  font-size: 12px;
  color: #4B6AAE;
}
.ts-title{
  color:#E56084 !important;
}
.target-audience-number-text {
  color: #6EC5B9;
}

/* Input Switch */
.switchCreateCampaign {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}
.switchCreateCampaign input {
  opacity: 0;
  width: 0;
  height: 0;
}
.sliderCreateCampaign {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.sliderCreateCampaign:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 3.5px;
  bottom: 3.4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
input:checked + .sliderCreateCampaign {
  background-color: #2196F3;
}
input:focus + .sliderCreateCampaign {
  box-shadow: 0 0 1px #2196F3;
}
input:checked + .sliderCreateCampaign:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(12.5px);
}
/* Rounded sliders */
.sliderCreateCampaign.round {
  border-radius: 34px;
}
.sliderCreateCampaign.round:before {
  border-radius: 50%;
}
/* Input Switch */
</style>
